import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { EmpreendimentoLista } from "../../../domain/models/empreendimento_lista";
import { IGetAllEmpreendimentoListaUseCase } from "../../../presentation/useCases/read/get_all_empreendimento_use_case";
import { IIncorporacaoRepository } from "../../repositories/incorporacao_repositories";

/**
 * IGetAllEmpreendimentoListaUseCase
 */

export class GetAllEmpreendimentoListaUseCase extends BasePaginatedUseCase<EmpreendimentoLista> implements IGetAllEmpreendimentoListaUseCase {

  constructor(private readonly repository: IIncorporacaoRepository) { super(); };

  getAllEmprendimentoLista(
    page: number,
    rowsPerPage: number): Promise<void>;

  async getAllEmprendimentoLista(
    page: number,
    rowsPerPage: number

  ): Promise<void> {
    const response = await this.repository.getAllEmprendimentoLista(
      page,
      rowsPerPage
    );
    this._items = response.items;
    this._pageSize = response.pageSize;
    this._currentPage = response.currentPage;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }


}

